import React, {useEffect, useRef, useState} from 'react'
import _ from 'lodash'
import clsx from 'clsx'

let _unique = 0

export const Select = ({
  label,
  placeholder,
  value,
  required,
  disabled,
  onChange = (ev, data, key) => {},
  items = [],
  render = (item, key, clickHandle) => {},
  selectedDisplay = (value, items) => {},
  classes = {root: '', input: '', menu: ''},
}) => {
  const [unique] = useState(`ds-select-${_unique++}`)
  const [toggle, setToggle] = useState(false)
  const refSelect = useRef()
  const refMenu = useRef()
  const [display, setDisplay] = useState('')

  useEffect(() => {
    setDisplay(selectedDisplay(value, items) || '')
  }, [value, items, selectedDisplay])

  const handleClickItem = (e, item, key) => {
    setToggle(false)
    onChange(e, item)
  }

  useEffect(() => {
    if (!toggle) {
      refMenu.current.style.display = `none`
      return
    }

    const rect = refSelect.current.getBoundingClientRect()

    refMenu.current.style.top = `${refSelect.current.offsetTop + rect.height + 4}px`
    refMenu.current.style.left = `${refSelect.current.offsetLeft}px`
    refMenu.current.style.width = `${rect.width}px`
    refMenu.current.style.display = `flex`

    const fn = event => {
      if (!event.target.matches(`.${unique}.ds-menu--basic, .${unique}.ds-menu--basic *`)) {
        setToggle(false)
      }
    }

    const d = document
    d.addEventListener('click', fn)

    return () => {
      d.removeEventListener('click', fn)
    }
  }, [toggle, unique])

  return (
    <>
      <fieldset
        ref={refSelect}
        required={required}
        disabled={disabled}
        class={clsx(
          'ds-form-input ds-form-input--dropdown',
          {'ds-form-input--selected': toggle},
          classes?.root
        )}
        onClick={() => setToggle(p => !p)}
      >
        {label && <legend>{label}</legend>}
        <input
          className={clsx('ds-text-ellipsis', classes?.root)}
          readOnly={true}
          placeholder={placeholder}
          value={display}
        />
      </fieldset>
      <div
        ref={refMenu}
        className={clsx('ds-menu--basic', classes?.menu, unique)}
        style={{display: 'none'}}
      >
        <div className="ds-menu--basic-wrapper">
          {_.map(items, (v, k) => render(v, k, handleClickItem))}
        </div>
      </div>
    </>
  )
}
